var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProviderSmileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13514_45485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 20.1693C16.0613 20.1693 20.1654 16.0652 20.1654 11.0026C20.1654 5.93999 16.0613 1.83594 10.9987 1.83594C5.93609 1.83594 1.83203 5.93999 1.83203 11.0026C1.83203 16.0652 5.93609 20.1693 10.9987 20.1693Z",
    stroke: "black",
    strokeWidth: 1.71875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 8.29479V8.20312M14.6654 8.29479V8.20312",
    stroke: "black",
    strokeWidth: 1.71875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 16.5026C11.9712 16.5026 12.9038 16.1163 13.5914 15.4287C14.2791 14.741 14.6654 13.8084 14.6654 12.8359H7.33203C7.33203 13.8084 7.71834 14.741 8.40597 15.4287C9.09361 16.1163 10.0262 16.5026 10.9987 16.5026Z",
    stroke: "black",
    strokeWidth: 1.71875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13514_45485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderSmileIcon);
export default __webpack_public_path__ + "static/media/provider-smile-icon.29223a68bb947063bcb572476abecd21.svg";
export { ForwardRef as ReactComponent };